/*
 * userReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 02-Jul-2024
 */

import produce from 'immer'
import { actionTypes } from '../actions/user'

const ACTION_HANDLERS = {
  [actionTypes.GET_TERMINAL_ID_LIST_SUCCESS]: produce((draft, action) => {
    draft.terminalIdList = action.payload
  }),
  [actionTypes.GET_TERMINAL_ID_LIST_FAILURE]: produce((draft) => {
    draft.terminalIdList = []
  }),
  [actionTypes.RETRIVE_USER_PROFILE_SUCCESS]: produce((draft, action) => {
    draft.userProfile = action.response
    draft.tenantId = action.response?.tenantId || null
    draft.merchant.merchantId = action.response?.merchant?.merchantId || null
    draft.roles = action.response?.user?.roles || []
    // TODO: populate merchantId, tenantId and roles
  }),
  [actionTypes.DO_SET_MERCHANT_SEARCH]: produce((draft, action) => {
    draft.merchantSearch = action.payload
  }),
  [actionTypes.DO_SET_SWITCHABLE_MERCHANTS]: produce((draft, action) => {
    if (draft.hasSwitchableMerchants === null || draft.hasSwitchableMerchants === undefined) {
      draft.hasSwitchableMerchants = action.payload
    }
  }),
  [actionTypes.DO_LOGOUT]: produce((draft) => {
    draft.hasSwitchableMerchants = null
  }),
  [actionTypes.RETRIEVE_SUBSCRIPTION_GLOBAL_SUCCESS]: produce((draft, action) => {
    draft.getSubscriptionArray = action?.response?.subscriptions || []
  }),
  [actionTypes.RETRIEVE_SUBSCRIPTION_GLOBAL_FAILURE]: produce((draft) => {
    draft.getSubscriptionArray = []
  })
  // @generator reducer:type:action
}

// The initial state of the user
const initialState = {
  terminalIdList: [],
  tenantId: null,
  merchant: {
    merchantId: null
  },
  userProfile: {},
  roles: [],
  merchantSearch: '',
  hasSwitchableMerchants: null,
  getSubscriptionArray: []
}

const user = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default user
